import { render, staticRenderFns } from "./EditorBlockPairObjects.vue?vue&type=template&id=d012f030&scoped=true"
import script from "./EditorBlockPairObjects.vue?vue&type=script&lang=js"
export * from "./EditorBlockPairObjects.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockPairObjects.vue?vue&type=style&index=0&id=d012f030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d012f030",
  null
  
)

export default component.exports